<template>
  <div class="page_middle_container page_middle_project_detail">
    <div class="page_middle_title">客户审批</div>
    <div class="page_middle_content">
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>公司名称：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_company"
              placeholder="请输入公司名称"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>税号：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_duty_paragraph"
              placeholder="请输入税号"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>开户银行：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_bank_name"
              placeholder="请输入开户银行"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>银行账号：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_bank_number"
              placeholder="请输入银行账号"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>公司电话：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_telephone"
              placeholder="请输入公司电话"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <span class="page_middle_row_key_required">*</span>公司地址：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_address"
              placeholder="请输入公司地址"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <!-- <span class="page_middle_row_key_required">*</span> -->
            客户姓名：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_name"
              placeholder="请输入客户姓名"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <!-- <span class="page_middle_row_key_required">*</span> -->
            客户手机：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_phone"
              placeholder="请输入客户手机"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="page_middle_row">
        <div class="page_middle_row_td">
          <div class="page_middle_row_key page_middle_row_key_min_width">
            <!-- <span class="page_middle_row_key_required">*</span> -->
            客户邮箱：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.customer_email"
              placeholder="请输入客户邮箱"
            ></el-input>
          </div>
        </div>
      </div>
      <div v-if="data.examine_status == 0 && !query.isWatch">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key page_middle_row_key_min_width">
              <span class="page_middle_row_key_required">*</span>审批结果：
            </div>
            <div class="page_middle_row_value">
              <el-select
                v-model="auditData.examine_status"
                placeholder="请选择审批结果"
              >
                <el-option :value="1" label="通过"></el-option>
                <el-option :value="2" label="驳回"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key page_middle_row_key_min_width">
              <span class="page_middle_row_key_required" v-if="auditData.examine_status == 2">*</span>审批备注：
            </div>
            <div class="page_middle_row_value">
              <el-input
                v-model.trim="auditData.examine_reason"
                placeholder="请输入审批备注"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_buttongroup">
          <el-button type="primary" @click="doCommit" :loading="loading"
            >审核</el-button
          >
        </div>
      </div>
      <div v-else>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key page_middle_row_key_min_width">
              审批结果：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;display: flex;align-items: center;">
              <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.examine_status == 1"><SuccessFilled /></el-icon>
              <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.examine_status == 2"><CircleCloseFilled /></el-icon>
              <span>
                {{ $config.types.auditResult[data.examine_status] }}
              </span>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key page_middle_row_key_min_width">
              审批备注：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              {{ data.examine_reason }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
export default {
  name: "audit",
  components: {
    SuccessFilled, 
    CircleCloseFilled 
  },
  data() {
    return {
      auditData: {
        id:"",
        examine_status: "",
        examine_reason: "",
        operation_url:window.location.href
      },
      data: {},
      loading: false,
      query: {},
    };
  },
  created() {
    this.query = { ...this.$route.query };
  },
  mounted() {
    if (this.query.id) {
      this.initData();
    }
  },
  methods: {
    initData() {
      let url = this.$tools.getURL(this.$urls.customerList.examine_list, {
        id: this.query.id,
      });
      this.$axios.get(url).then((res) => {
          this.data = res.data;
          this.auditData.id=res.data.id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    verifyData() {
      if (!this.auditData.examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.examine_status == 2 &&
        !this.auditData.examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.customerList.examine;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
/* .page_middle_detail .page_middle_field_name {
  
} */
</style>